<template>
  <v-container class="py-8">
    <v-row class="mb-6">
      <v-col cols="12">
        <h1 class="text-h3 font-weight-bold text-center text-accent mb-2">Inloggen</h1>
        <div class="text-center">
          <v-divider class="mb-4 mx-auto" width="100" thickness="3" color="primary"></v-divider>
        </div>
        <p class="text-center text-body-1 mx-auto" style="max-width: 800px">
          Beheerders kunnen hier inloggen om het preekrooster te uploaden.
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="7">
        <v-card elevation="2">
          <v-card-text>
            <div v-if="auth.isAuthenticated" class="mb-4">
              <div class="text-subtitle-1">Ingelogd als</div>
              <div class="text-body-1">{{ auth.userDetails ?? auth.userId }}</div>
            </div>

            <div v-else class="mb-4">
              <div class="text-body-1">U bent niet ingelogd.</div>
            </div>

            <div class="d-flex flex-column flex-sm-row ga-3">
              <v-btn
                v-if="!auth.isAuthenticated"
                color="primary"
                prepend-icon="mdi-login"
                :href="loginUrl"
              >
                Inloggen met Microsoft
              </v-btn>

              <v-btn
                v-else
                color="secondary"
                variant="tonal"
                prepend-icon="mdi-logout"
                :href="logoutUrl"
              >
                Uitloggen
              </v-btn>

              <v-btn variant="text" @click="auth.refresh" prepend-icon="mdi-refresh">
                Vernieuwen
              </v-btn>
            </div>

            <v-alert
              v-if="auth.isAuthenticated && !auth.canUploadPreekrooster"
              class="mt-4"
              type="warning"
              variant="tonal"
              icon="mdi-shield-alert"
            >
              U bent ingelogd, maar heeft geen rechten om het preekrooster te uploaden.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useAuthStore } from './authStore';

const auth = useAuthStore();

const loginUrl = computed(() => '/.auth/login/aad?post_login_redirect_uri=/');
const logoutUrl = computed(() => '/.auth/logout?post_logout_redirect_uri=/');

onMounted(() => {
  void auth.refresh();
});
</script>
